import { useEffect, useState } from "react";
import { UserCheck } from "lucide-react";
import { get, Card, chf, fmtDate, Empty, inputCls } from "./shared";

export const Customers = () => {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { get("/customers").then(setRows).catch(() => setRows([])); }, []);
  const list = (rows || []).filter((c) => (c.email + (c.name || "")).toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="space-y-5" data-testid="admin-customers">
      <input data-testid="customers-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un client…" className={`${inputCls} w-full max-w-sm`} />
      {rows === null ? <Empty>Chargement…</Empty> : list.length === 0 ? <Empty>Aucun client.</Empty> : (
        <Card className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] font-mono uppercase tracking-wide text-stone-400 border-b border-stone-100">
                <th className="px-5 py-3">Client</th><th className="px-5 py-3">Commandes</th><th className="px-5 py-3">Total dépensé</th><th className="px-5 py-3">Abos</th><th className="px-5 py-3">1ère commande</th><th className="px-5 py-3">Dernière</th><th className="px-5 py-3">Compte</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {list.map((c) => (
                <tr key={c.email} data-testid={`customer-row-${c.email}`} className="hover:bg-stone-50">
                  <td className="px-5 py-3"><p className="text-stone-900">{c.name || "—"}</p><a href={`mailto:${c.email}`} className="font-mono text-xs text-stone-500 hover:text-[#C85A32]">{c.email}</a></td>
                  <td className="px-5 py-3 font-mono">{c.orders}</td>
                  <td className="px-5 py-3 font-mono">{chf(c.spent)}</td>
                  <td className="px-5 py-3 font-mono">{c.subscriptions || 0}</td>
                  <td className="px-5 py-3 text-xs text-stone-500">{fmtDate(c.first_order)}</td>
                  <td className="px-5 py-3 text-xs text-stone-500">{fmtDate(c.last_order)}</td>
                  <td className="px-5 py-3">{c.has_account ? <span className="inline-flex items-center gap-1 text-[10px] font-mono uppercase text-[#4A624E]"><UserCheck size={12} /> inscrit</span> : <span className="text-[10px] font-mono uppercase text-stone-400">invité</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
};
